import { useDomainRepository } from "hooks";
import BusinessLogicException from "exceptions/BusinessLogicException";
import { RequestQueryMapper } from "util/request-query-mapper";
import {
    makeState,
    Repository as NotificationsRepository,
    type NotificationsRepositoryState
} from "./repository";
import { reducer, RepositoryActionType, useRequest } from "../Repository";

export const useNotifications = <TNotification extends object>(requestHandler: (searchQueryParams?: string) => Promise<Response>) => {
    const request = useRequest();

    const repository = useDomainRepository<
        NotificationsRepositoryState<TNotification>,
        RepositoryActionType
    >({
        reducer: reducer(makeState<TNotification>()),
        initializerArg: makeState<TNotification>()(),
        factory: (state, dispatch) => new NotificationsRepository(
            state,
            dispatch,
            async (globalSearchQueryParams?: string) => {
                const { data } = await request((searchQueryParams?: string) => requestHandler(
                    RequestQueryMapper.from(globalSearchQueryParams)
                        .concat(`${searchQueryParams}`)
                        .toString()
                ));

                return data;
            }
        )
    });

    if (repository instanceof NotificationsRepository) {
        return repository;
    }

    throw new BusinessLogicException('Repository is not an instance of NotificationsRepository', {
        repository
    });
};

export default useNotifications;
